// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__QFmNc","text":"Checkbox_text__2O_lz"};